export default {
  dialogTitle: "Uploads",
  state: {
    queued: "Queued",
    uploading: "Uploading... ({{progress}} percent)",
    failed: "Upload failed",
    finished: "Finished upload"
  }
};
